import store from '@/store';

export default {
  setChurchList(state, list) {
    state.churchList = [...list] || [];
  }
};
